import React from "react";
import { Field } from "react-final-form";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../components/Autocomplete";
import { getDurationUnits } from "../../../../../constants";

const durationUnitWithoutDays = getDurationUnits("Program")
  .slice(1)
  .slice(0, -1);

const useStyles = makeStyles(() => ({
  tuition: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
    lineHeight: 1,
    marginBottom: 16,
    marginTop: 22,
  },
}));

const ProgramDuration = ({ name }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.tuition}>Program Duration</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Duration Period"
            options={durationUnitWithoutDays}
            placeholder="Please Select"
            name={`${name}.durationUnit`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            type="text"
            label="Duration"
            placeholder={"Only numbers"}
            name={`${name}.durationAmount`}
            component={BootstrapInput}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ProgramDuration;
